import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BasketCartItemError } from '@as-react/common-types';
import { ProductTileBasketOverview } from '../../product-tile/basket-overview/ProductTileBasketOverview';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useAemConfig } from '@as-react/common-components';
import { Banner, StackBlock, useMediaQueryMatchesOnDesktop } from '@yonderland/andes-react';
import { useEffect, useRef } from 'react';
import { ScrollUtil } from '../../../util/ScrollUtil';
export const BasketOverviewItem = ({ product, isDisabled, storeName }) => {
    var _a;
    const errorRef = useRef(null);
    const { t } = useTranslation([I18N_NAMESPACES.navigation, I18N_NAMESPACES.checkout, I18N_NAMESPACES.product]);
    const { market, mainWebShop, isShopLanding, feature_toggles: { ecocheques_cart_item_message }, } = useAemConfig();
    const getMarket = () => (market === 'uk' ? 'uk' : mainWebShop);
    const showEcochequesMessage = ecocheques_cart_item_message && ((_a = product.features) === null || _a === void 0 ? void 0 : _a.includes('ecocheques_accepted'));
    const isDesktop = useMediaQueryMatchesOnDesktop();
    useEffect(() => {
        if (product.errorState === BasketCartItemError.ADD_FAILED && (errorRef === null || errorRef === void 0 ? void 0 : errorRef.current)) {
            ScrollUtil.scrollToErrorElement(errorRef.current, isDesktop);
        }
    }, [product.errorState]);
    return (_jsxs(StackBlock, { gap: "3", testId: `basket-product-tile-${product.productId}`, children: [product.errorState === BasketCartItemError.ADD_FAILED && (_jsx("div", { ref: errorRef, children: _jsx(Banner, { status: "error", text: t(`${I18N_NAMESPACES.checkout}:basket.addProductFailed`) }) })), isDisabled && (_jsx("div", { ref: errorRef, children: _jsx(Banner, { status: "error", tooltip: {
                        hasCloseBtn: false,
                        text: t(`${I18N_NAMESPACES.product}:product.store.source.excluded.${getMarket()}.info`),
                    }, text: storeName
                        ? t(`${I18N_NAMESPACES.product}:product.store.source.excluded.${getMarket()}.error`, {
                            storeName,
                        })
                        : t(`${I18N_NAMESPACES.product}:product.store.source.excluded.error`, {
                            storeName,
                        }) }) })), _jsx(ProductTileBasketOverview, { product: product, isDisabled: isDisabled }, product.productCode), showEcochequesMessage && (_jsx(Banner, { hideIcon: true, status: "sustainability", testId: "ecocheque_accepted_message", text: t(`${I18N_NAMESPACES.checkout}:basket.feature.ecocheques_accepted.message`), tooltip: isShopLanding
                    ? undefined
                    : {
                        text: t(`${I18N_NAMESPACES.checkout}:basket.feature.ecocheques_accepted.tooltip`),
                        strategy: 'fixed',
                        hasCloseBtn: false,
                    } }))] }));
};
